import { Component, Input } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto, Szme038aResponseCdtmnyMeisaiInfDto} from 'sg-api';
import { DateDurationPipe } from '../../../../../sg-kd-shared/pipes/date-duration.pipe';

/**
 * 売掛金詳細
 *
 * @export
 * @class UrikakekinElectricDetailComponent
 */

@Component({
  selector: 'app-urikakekin-electric-detail',
  templateUrl: './urikakekin-electric-detail.component.html',
  styleUrls: ['./urikakekin-electric-detail.component.scss'],
  providers: [DateDurationPipe]
})
export class UrikakekinElectricDetailComponent{
    
  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;
  @Input() conCapKva: string; 
  @Input() conCapKvaUnit: string; 
  @Input() prdClsfyDiv: string; 

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'detailHyojiAname',
    'chargeCodeMny'
  ];

  constructor() { 
  } 

}
